// video.js エントリーポイント（VR あり）。
// ライブラリ視聴コンポーネント（VR 動画対応）でのみ使用する。

import videojs from '@/video_player/plugins';
import 'videojs-vr/dist/videojs-vr.min.js';
import 'videojs-vr/dist/videojs-vr.css';
import { createVodSettings, createLiveSettings } from '@/video_player/settings';
import { calc_viewing_time } from '@/video_player/utils';

window.HELP_IMPROVE_VIDEOJS = false;
window.videojs = videojs;
window.calc_viewing_time = calc_viewing_time;
window.createVodSettings = createVodSettings;
window.createLiveSettings = createLiveSettings;
